<template>
  <div class="text-visibility-toggle">
    <LabeledText :label="label">
      <div v-if="isFieldEmpty">
        -
      </div>
      <div class="content-wrapper" v-else>
        <div v-if="isVisible">{{ visibleText | capitalize }}</div>
        <div class="hidden-text" v-else-if="visibleText" />
        <span class="trigger" @click="triggerVisibility" v-if="visibleText">
          {{ visibilityText }}
        </span>
      </div>
    </LabeledText>
  </div>
</template>

<script>
import LabeledText from "@/components/common/BaseDetails/LabeledText";
import { isBoolean } from "lodash";

export default {
  name: "TextWithVisibilityToggle",
  components: {
    LabeledText
  },
  props: {
    label: String,
    text: [String, Boolean, Number]
  },
  data() {
    return {
      isVisible: false
    };
  },
  computed: {
    visibilityText() {
      return this.isVisible ? "Hide" : "Show";
    },
    visibleText() {
      return isBoolean(this.text)
        ? this.convertToYesOrNo(this.text)
        : this.text;
    },
    isFieldEmpty() {
      return !this.text && !isBoolean(this.text);
    }
  },
  methods: {
    triggerVisibility() {
      this.isVisible = !this.isVisible;
    },
    convertToYesOrNo() {
      return this.text ? "Yes" : "No";
    }
  }
};
</script>

<style scoped lang="scss">
.text-visibility-toggle {
  .content-wrapper {
    display: flex;
    align-items: center;
    min-height: 40px;
  }
  .trigger {
    min-width: fit-content;
    cursor: pointer;
    margin-left: 10px;
    color: $primary-darker;
    font-weight: bold;
  }
}
</style>
